import React from "react";
import { Button, Modal } from "react-bootstrap";

function ModalCommon(prop) {
  const {
    modalState: { modal, data },
    setModalState,
    modalData,
  } = prop;

  if (!modal) {
    return null;
  }

  return (
    <div>
      <Modal
        show={modal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="freeze-unfreeze-modal"
      >
        {data?.button?.secondary && (
          <Modal.Header>
            <button
              type="button"
              onClick={() => {
                setModalState({ modal: false, data: {} });
              }}
              className="btn-close filter-closeBtn"
              aria-label="Close"
            >
              <span className="icon-close"></span>
            </button>
          </Modal.Header>
        )}
        <Modal.Body>
          <img
            alt="warning-icon"
            src={data?.icon}
            className="image-modal mt-4"
          />
          <h4 className="section-title mt-4">{data?.text} </h4>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-yes-no mt-2 mb-4">
            {data?.button?.secondary && (
              <Button
                className="no-btn confirm-btn mr-4"
                onClick={() => {
                  setModalState({ modal: false, data: {} });
                }}
              >
                {data?.button?.secondary}
              </Button>
            )}
            {data?.button?.primary && (
              <Button
                className="yes-btn confirm-btn"
                onClick={() => {
                  if (prop?.modalState.onPrimaryClick) {
                    prop?.modalState.onPrimaryClick();
                  }
                  setModalState({ modal: false, data: {} });
                }}
              >
                {data?.button?.primary}
              </Button>
            )}
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ModalCommon;
